// extracted by mini-css-extract-plugin
module.exports = {"btn":"ResearchCenter_btn__1pQtN","researchCenter":"ResearchCenter_researchCenter__2kmOx","researchSubject":"ResearchCenter_researchSubject__2VuYT"};